import DatePicker from "react-datepicker";

export const defaultFormTemplate = {
  receipt_id: null,
  customer_id: null,
  company_id: null,
  income_id: null,
  account_id: null,
  related_to: null,            // 'project' | 'opportunity'
  record_id: null,
  receipt_number: null,
  amount: null,                // decimal(18,2)
  currency: 'INR',
  fx_rate: 1,                  // decimal(18,6)
  notes: null,
  mode_of_payment: null,       // legacy int (optional)
  payment_mode: 'BANK',        // 'CASH' | 'BANK' | 'UPI' | 'CHEQUE' | 'CARD' | 'OTHER'
  bank_account_id: null,
  transaction_ref: null,
  transaction_date: null,      // 'YYYY-MM-DD'
  receipt_date: null,          // 'YYYY-MM-DD'
  status: 'POSTED',            // 'DRAFT' | 'POSTED' | 'CANCELLED'
  invoice_id: null,            // legacy CSV; prefer allocations table
  show_history: 'no',          // 'yes' | 'no'
  pending_amount: null,        // legacy; recommend compute-only
  attachment_url: null,
  created_by: null,
  updated_by: null,
  created_date: null,          // 'YYYY-MM-DD HH:mm:ss'
  updated_at: null             // 'YYYY-MM-DD HH:mm:ss'
};


export const defaultColumns = [
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"invoiceID","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"customer_id","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
];
 export const  skipFields=['account_id','company_id','income_id','related_to','record_id','fx_rate','mode_of_payment','bank_account_id','show_history','pending_amount','attachment_url','currency','transaction_date'];
export const  filterSkipFields=['account_id','company_id','income_id','related_to','record_id','fx_rate','mode_of_payment','bank_account_id','show_history','pending_amount','attachment_url','currency','transaction_date'];

export const validationRules = {
          customer_id: { required: true},
          amount: { required: true},
          bank_account_id: { required: true},
          payment_mode: { required: true},
          payment_log_date: { required: true},
          // due_date: { required: true },
          // description: { required: false }
        };
export const columnLabels = {
        receipt_id:"Receipt ID",
        invoice_number:'Invoice Number',
        invoice_id:'Invoice ID',
        customer_id:"Customer Name",
        receipt_date:"Transaction Date"
      };

export const staticJoined = [
        {
          field: 'customer',
          fieldtype: 'customer',
          joinedTable: 'customer',
          select: 'customer_id,name',
          primaryKey: 'customer_id',
          slug: ''
        },
      ];
export  const fieldOverrides = {
      customer_id: {
        type: 'smartSelectInput',
        config: { label: '',type: 'customer',
          source: 'customer',
          valueKey:'customer_id',
          placeholder: 'Select Customer',
          check: 'name',
          getLabel: (item) => `${item.name}`,
          getValue: (item) => item.customer_id,
          allowAddNew: true,preload: true,cache: true,showRecent: true,multi:false,
          list: 'name,customer_id'
        }
      },
      notes:{
        type:"editor",
        showEditorInitially:true,
      },
       payment_mode: {
          type: 'dropdown',
          label: 'Payment Mode',
          options: [
              { value: 'CASH', label: 'CASH' },
              { value: 'BANK', label: 'BANK' },
              { value: 'UPI', label: 'UPI' },
              { value: 'CHEQUE', label: 'CHEQUE' },
              { value: 'CARD', label: 'CARD' },
              { value: 'OTHER', label: 'OTHER' },
            ]
          },
           payment_log_date:{
                type:'date',
                defaultToday: false,
                preventPast: false, // disallow selecting past dates
                preventFuture: true // disallow selecting future dates
                //limitTo: 'month' // 'week' or 'year' also supported
               // preventBefore: '2025-06-10'
                //preventAfter: '2025-12-31'
            },
      bank_account_id: {
        type: 'smartSelectInput',
        config: { label: '',type: 'accounts',
          source: 'accounts',
          valueKey:'account_id',
          placeholder: 'Select Bank Account',
          check: 'name',
          getLabel: (item) => `${item.name}`,
          getValue: (item) => item.account_id,
          allowAddNew: true,preload: true,cache: true,showRecent: true,multi:false,
          list: 'name,account_id'
        },
      },
      currency: {
        type: 'smartSelectInput',
        config: { label: '',type: 'currency',
          source: 'currency',
          valueKey:'currency_id',
          placeholder: 'Select Currency',
          check: 'name',
          getLabel: (item) => `${item.name}`,
          getValue: (item) => item.currency_id,
          allowAddNew: true,preload: true,cache: true,showRecent: true,multi:false,
          list: 'name,currency_code,currency_id'
        },
      },
    };

          
export const directSchemaTemplate = [
  { Field: 'receipt_id',       Type: 'int' },
  { Field: 'customer_id',      Type: 'int' },
  { Field: 'company_id',       Type: 'int' },
  { Field: 'income_id',        Type: 'int' },
  { Field: 'account_id',       Type: 'int' },
  { Field: 'related_to',       Type: "enum('project','opportunity')" },
  { Field: 'record_id',        Type: 'int' },
  { Field: 'receipt_number',   Type: 'varchar(50)' },
  { Field: 'amount',           Type: 'decimal(18,2)' },
  { Field: 'currency',         Type: 'varchar(10)' },
  { Field: 'fx_rate',          Type: 'decimal(18,6)' },
  { Field: 'notes',            Type: 'text' },
  { Field: 'mode_of_payment',  Type: 'int' },
  { Field: 'payment_mode',     Type: "enum('CASH','BANK','UPI','CHEQUE','CARD','OTHER')" },
  { Field: 'bank_account_id',  Type: 'int' },
  { Field: 'transaction_ref',  Type: 'varchar(128)' },
  { Field: 'transaction_date', Type: 'date' },
  { Field: 'receipt_date',     Type: 'date' },
  { Field: 'status',           Type: "enum('DRAFT','POSTED','CANCELLED')" },
  { Field: 'invoice_id',       Type: 'varchar(25)' },
  { Field: 'show_history',     Type: "enum('yes','no')" },
  { Field: 'pending_amount',   Type: 'varchar(50)' },
  { Field: 'attachment_url',   Type: 'varchar(255)' },
  { Field: 'created_by',       Type: 'int' },
  { Field: 'updated_by',       Type: 'int' },
  { Field: 'created_date',     Type: 'datetime' },
  { Field: 'updated_at',       Type: 'datetime' },
  { Field: 'payment_log_date',       Type: 'date' }
  
];
export const layout = [
    {
      label: 'Basic Info',
      row: [
      { field: 'customer_id',colSize:'w-full mb-3 md:w-1/3' },
      { field: 'amount' ,colSize:'w-full mb-3 md:w-1/3'},
      { field: 'bank_account_id'},
      ]
    },
    {
      row: [
        { field: 'payment_mode',colSize:'w-full mb-3 md:w-1/3'},
        { field: 'transaction_ref' ,colSize:'w-full mb-3 md:w-1/3'},
        { field: 'payment_log_date'},
      ]
    },
    {
      row: [
      { field: 'currency',colSize:'w-full mb-3 md:w-1/3' },
      { field: 'fx_rate',colSize:'w-full mb-3 md:w-1/3'},
      ]
    },
    {
      row: [
      { field: 'notes'},
      ]
    },
    {
      row: [
       { addcustomFieldBtn: true },{ customFieldsPlaceholder: true }
      ]
    },
  ];
export const infoIcons = {
};